"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _simpleDeepEqual = require("../utils/simpleDeepEqual");

var _dedupArray = _interopRequireDefault(require("../utils/dedupArray"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var deepmerge = require('deepmerge');

var StateManager = function StateManager(client) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, StateManager);
  (0, _defineProperty2["default"])(this, "_state", void 0);
  (0, _defineProperty2["default"])(this, "_client", void 0);
  (0, _defineProperty2["default"])(this, "update", function (stateChunk) {
    if (_this._state.view && stateChunk.view && !(0, _simpleDeepEqual.deepEquals)(stateChunk.view, _this._state.view)) {
      // If we're updating the view, move the previous view to the viewPrevious param:
      _this._state = deepmerge(_this._state, _objectSpread({
        viewPrevious: _this._state.view
      }, stateChunk), {
        arrayMerge: function arrayMerge(source, target) {
          return (0, _dedupArray["default"])(source, target);
        }
      });
    }

    _this._state = deepmerge(_this._state, stateChunk, {
      arrayMerge: function arrayMerge(source, target) {
        return (0, _dedupArray["default"])(source, target);
      }
    });

    if (stateChunk.view) {
      _this._client.viewPreviousCache.update(_this._state.view);
    }
  });
  (0, _defineProperty2["default"])(this, "init", this.update);
  (0, _defineProperty2["default"])(this, "get", function () {
    return deepmerge({}, _this._state);
  });
  (0, _defineProperty2["default"])(this, "reset", function () {
    _this._state = {};
  });
  this._state = {};
  this._client = client;
};

var _default = StateManager;
exports["default"] = _default;